import { createActionFactory, Feature } from '../../shared';
import type { Route } from '../state/view/navigationState';
import type { Dispatch } from 'redux';

export const setRouteAction = createActionFactory<{ route: Route }>(
    'SetRouteAction',
    Feature.Bootstrap,
    action => {
        return {
            route: action.payload.route,
        };
    }
);

export const setRoute = (dispatch: Dispatch) => (route: Route) =>
    dispatch(setRouteAction({ route: route }));
export type { Action } from '../../shared';
